import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import posed, { PoseGroup } from 'react-pose';
import Dot from './Dot';
import Card from './Card';

const Container = styled.div`
  background-color: #e4ff5f;
  padding: 20px;
  text-align: center;
`;

const Box = styled.div`
  max-width: 1024px;
  margin: 0 auto;
  padding: 30px 0;
`;

const CardAnimate = posed.div({
  enter: {
    opacity: 1
  },
  exit: {
    opacity: 0
  }
});

const DATA = [
  {
    avatar: 'recommender1.png',
    message:
      '“Popshop Live is helping me create a Spiritual Brand that turns my viewers into my new family!”',
    author: '- Lisa Dolan, Crystals, Tarot and Everything In-between!'
  },
  {
    avatar: 'recommender2.png',
    message:
      '“Popshop is an excellent platform to execute sales, live video strategies, and build brand awareness” ',
    author: '- Oscar (El Machete Hot Sauce)'
  },
  {
    avatar: 'recommender3.png',
    message:
      'I absolutely LOVE using PopShop to sell my products! It expands my market to reach people I wouldn’t normally have access to, all while making it super easy to collect payments and ship out products. It’s also great to be able to interact live with my customers and answer any questions they may have. Looking forward to continuing to grow my business with PopShop!”',
    author: '- Miriam Khan',
    className: 'recommend-small'
  }
];

export default () => {
  const [num, setNum] = useState(1);
  useEffect(() => {
    let unsubscribe = false;
    setTimeout(() => {
      if (unsubscribe) {
        return;
      }
      setNum(num + 1 > DATA.length ? 1 : num + 1);
    }, 5000);
    return () => {
      unsubscribe = true;
    };
  }, [num]);

  return (
    <Container onClick={() => setNum(num + 1 > DATA.length ? 1 : num + 1)}>
      <Box>
        <PoseGroup>
          {DATA.map(({ avatar, message, author, className }, index) => {
            if (num === index + 1) {
              return (
                <CardAnimate key={index}>
                  <Card
                    avatar={avatar}
                    message={message}
                    author={author}
                    className={className}
                  />
                </CardAnimate>
              );
            }
            return undefined;
          })}
        </PoseGroup>
        {DATA.map((data, index) => {
          return <Dot key={index} />;
        })}
      </Box>
    </Container>
  );
};
